import { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Tooltip.module.css';

interface TooltipProps {
  text: string;
  linkTo: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom';
}

export function Tooltip({ text, linkTo, children, position = 'top' }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);
  const timeoutRef = useRef<number | null>(null);
  const navigate = useNavigate();

  const handleMouseEnter = () => {
    timeoutRef.current = window.setTimeout(() => {
      setIsVisible(true);
    }, 200); // Small delay to prevent flicker
  };

  const handleMouseLeave = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setIsVisible(false);
  };

  const handleClick = () => {
    navigate(linkTo);
  };

  return (
    <div
      className={styles.tooltipWrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {children}
      {isVisible && (
        <div className={`${styles.tooltip} ${position === 'bottom' ? styles.tooltipBottom : ''}`}>
          <span className={styles.tooltipText}>{text}</span>
          <div className={`${styles.tooltipArrow} ${position === 'bottom' ? styles.tooltipArrowBottom : ''}`} />
        </div>
      )}
    </div>
  );
}
